/**
 * Sigil for implicit end() calls that should not
 * trigger an error if the user then calls t.end()
 */
export const IMPLICIT = Symbol.for('implicit end')
